import React, {PropTypes} from 'react';
import {Link} from 'react-router';

const LoginForm = ({onSubmit, onChange, errors, user}) => (

    <div className="container">
        <div className="row z-depth-2 green darken-4 ">
          <form className="col s12" action="/" onSubmit={onSubmit}>


                    <h2 className="center white-text">Entrar</h2>

                    <div className="row" >

                            {errors.summary && <p className="red darken-3">{errors.summary}</p>}
                            <div className="col s12">
                                <div className="input-field col s12">
                                    <input id="email" type="email" name="email" className="validate white-text" onChange={onChange} value={user.email}/>
                                    <label htmlFor="email" className="white-text " data-error={errors.email}>Email</label>
                                </div>
                            </div>
                            <div className="col s12">
                                <div className="input-field col s12 ">
                                    <input id="password" type="password" name="password" className="validate white-text" onChange={onChange} value={user.password}/>
                                    <label htmlFor="password" className="white-text" data-error={errors.password}>Password</label>
                                </div>
                            </div>

                    </div>

                <div className="row ">
                    <button className="btn btn-large col s8 offset-s2 waves-effect grey lighten-3 green-text">Entrar</button>
                </div>


            </form>
        </div>
    </div>
);

LoginForm.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired
};

export default LoginForm;



// WEBPACK FOOTER //
// ./src/components/LoginForm.js